<template>
    <div class="information-overlay" :class="{ active: status }" ref="informationOverlay">
        <div class="description">
            <EnterSvg v-if="status === 'enter-join'" />
            <EnterSvg v-if="status === 'enter-create'" />
            <div class="material-icons" v-if="status === 'inactive'">block</div>
            <span>{{ statusText[status] }}</span>
        </div>
        <SupsisButton @click="clickButton" v-if="['enter-join', 'enter-create'].includes(status)" primary>
            {{ status === "enter-join" ? "Sohbete Katıl" : "Sohbet Başlat" }}
        </SupsisButton>
        <SupsisButton
            @click="startWhatsappChat"
            v-if="['enter-create'].includes(status) && isWhatsapp() && whatsappChannels.length > 1"
            primary
        >
            Farklı Kanal ile Sohbet Başlat
        </SupsisButton>
        <Modal2
            v-if="showWhatsappChatStarterModal"
            :show-footer="false"
            class="modal-wp-chat-starter"
            title="Whatsapp Chat Başlatıcı"
            @cancel="() => (showWhatsappChatStarterModal = false)"
        >
            <WhatsappChatStarter
                :default-phone-number="contact.whatsappNumber"
                channel-override
                phone-number-override
                @close="() => (showWhatsappChatStarterModal = false)"
                :default-email="contact.email"
                :default-name="contact.name || contact.fullname"
            />
        </Modal2>
    </div>
</template>

<script>
import { log2 } from "../../../../../utils/log2";
import { mapActions, mapState } from "vuex";
import EnterSvg from "../../svg/EnterSvg.vue";
import SupsisButton from "../../../../../views/Pages/Settings/components/SupsisButton.vue";
import Modal2 from "../../../../common/Modal2.vue";
import WhatsappChatStarter from "../../../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import _ from "lodash";

const log = log2("InformationOverlay");
export default {
    name: "InformationOverlay",
    components: { WhatsappChatStarter, Modal2, SupsisButton, EnterSvg },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        status: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapState({
            whatsappChannels: (state) => state.channel.channels.filter((x) => x.type.startsWith("whatsapp")),
        }),
    },
    data: () => ({
        handleEnterKey: null,
        statusText: {
            "enter-join": "Enter tuşuna basarak sohbete katılabilirsiniz",
            "enter-create": "Enter tuşuna basarak sohbet başlatabilirsin",
            inactive: "Bu Kişiye Mesaj Gönderemezsiniz",
        },
        showWhatsappChatStarterModal: false,
    }),
    mounted() {
        this.$emit("blur-editor");
        this.handleEnterKey = (e) => {
            const isInput = _.get(e, "target.nodeName") === "INPUT";
            if (isInput) return;
            if (e.key === "Enter" && this.status === "enter-join") {
                this.clickButton();
            } else if (e.key === "Enter" && this.status === "enter-create") {
                this.clickButton();
            }
        };
        document.addEventListener("keydown", this.handleEnterKey);
    },
    methods: {
        ...mapActions({
            joinContactConversation: "chat/joinContactConversation",
            startChat: "chat/startChat",
        }),
        clickButton() {
            if (this.status === "enter-join") {
                this.joinContactConversation(this.contact);
            } else if (this.status === "enter-create") {
                this.startChat(this.contact);
            }
            this.$emit("focus-editor");
        },
        isWhatsapp() {
            return ["whatsapp", "meta-leads"].includes(this.contact?.platform);
        },
        startWhatsappChat() {
            if (this.contact.whatsappNumber) {
                this.showWhatsappChatStarterModal = true;
            } else {
                this.$message.error("Phone number is not available");
            }
        },
    },
    beforeDestroy() {
        if (this.handleEnterKey) {
            document.removeEventListener("keydown", this.handleEnterKey);
        }
    },
};
</script>
<style lang="scss">
.information-overlay {
    &.active {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.63);
        z-index: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 18px;
        color: black;
        justify-content: center;
        flex-direction: column;

        .description {
            display: flex;
            align-items: center;
            gap: 4px;
            justify-content: center;
        }
    }
}
</style>
